module.exports = __webpack_public_path__ + "img/purchase-3_1.0d6fc6f6.png";